import { render } from "./ProcurementRecords.vue?vue&type=template&id=5472e7f7"
import script from "./ProcurementRecords.vue?vue&type=script&lang=js"
export * from "./ProcurementRecords.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__